import history from 'services/history'

export default (t) => [
  {
    title: t('Administration'),
    id: 'admin',
    onClick: () => {
      return history.replace('/administration-permissions/Roles')
    }
  },
  {
    title: t('Translations'),
    id: 'translations',
    onClick: () => {
      return history.replace('/translations/translationTables')
    }
  }
]
